import { SUPPORT_EMAIL } from '^/constants/defaultText';
import { Language, RequestPhotoStatus } from '^/types';

const { PENDING, REQUESTED, FAILED, COMPLETED, READY }: typeof RequestPhotoStatus =
  RequestPhotoStatus;

export default {
  emptyState: {
    title: {
      [Language.EN_US]: 'No viewpoints yet',
      [Language.KO_KR]: '아직 뷰포인트가 없습니다',
    },
    infoText: {
      [Language.EN_US]: "Press the 'Capture Viewpoint' button",
      [Language.KO_KR]: "'뷰포인트 캡처' 버튼을 눌러주세요",
    },
  },
  viewpoint: {
    [Language.EN_US]: 'View point',
    [Language.KO_KR]: '뷰포인트',
  },
  rename: {
    [Language.EN_US]: 'Rename',
    [Language.KO_KR]: '이름 변경',
  },
  delete: {
    [Language.EN_US]: 'Delete',
    [Language.KO_KR]: '삭제',
  },
  centerOnMap: {
    [Language.EN_US]: 'View on map',
    [Language.KO_KR]: '지도에서 보기',
  },
  requestPhotos: {
    [Language.EN_US]: 'Request Photos',
    [Language.KO_KR]: '사진 요청보내기',
  },
  photosRequested: {
    [Language.EN_US]: 'Photos Requested',
    [Language.KO_KR]: '사진 요청됨',
  },
  successfullyRequested: {
    [Language.EN_US]: 'Successfully requested',
    [Language.KO_KR]: '성공적으로 요청되었습니다',
  },
  requestCompleted: {
    [Language.EN_US]: 'Request completed',
    [Language.KO_KR]: '요청 완료',
  },
  alreadyRequested: {
    [Language.EN_US]: `You already requested for free trial. please contact us for purchase options. ${SUPPORT_EMAIL}`,
    [Language.KO_KR]: `이미 무료 요청 횟수를 모두 사용 하셨습니다. 구매를 통해 추가 요청이 필요하신 경우에는 비즈니스 문의 부탁드립니다. ${SUPPORT_EMAIL}`,
  },
  freeLimit: {
    // eslint-disable-next-line max-len
    [Language.EN_US]: `The free plan allows up to 10 captures. If you need additional captures, please contact us for purchase options. ${SUPPORT_EMAIL}`,
    [Language.KO_KR]: `무료로 캡쳐 가능한 갯수는 10개이며, 구매를 통해 추가 요청이 필요하시면 비즈니스 문의 부탁드립니다. ${SUPPORT_EMAIL}`,
  },
  minMaxDays: (min: number, max: number) => ({
    [Language.EN_US]: `This will take a minimum of ${min} days and a maximum of ${max} weeks.`,
    [Language.KO_KR]: `요청한 사진이 업로드 되기까지 ${min}일에서 길게는 ${max}주까지 소요될 수 있습니다.`,
  }),
  tippyText: {
    [PENDING]: {
      [Language.EN_US]: 'Not requested yet',
      [Language.KO_KR]: '아직 요청되지 않음',
    },
    [REQUESTED]: {
      [Language.EN_US]: 'Request completed',
      [Language.KO_KR]: '요청 완료',
    },
    [FAILED]: {
      [Language.EN_US]: 'Shooting restricted',
      [Language.KO_KR]: '촬영 제한됨',
    },
    [COMPLETED]: {
      [Language.EN_US]: 'Drone photo',
      [Language.KO_KR]: '드론 촬영 사진',
    },
    [READY]: {
      [Language.EN_US]: 'Ready',
      [Language.KO_KR]: '준비됨',
    },
  },
};
